export default __webpack_public_path__ + "static/media/1.b46577e3.jpg";